const style = (theme) => {
  const output = {
    root: {
      position: 'relative',
    },
    counter: {
      width: 18,
      height: 18,
      background: theme.colors[5],
      color: theme.colors[0],
      borderRadius: '50%',
      fontSize: 9,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      right: '-5px',
      top: '-5px',
      opacity: 0,
    },
    visible: {
      opacity: 1,
      animation: '$bounce 0.6s',
    },
    '@keyframes bounce': {
      'from, to': { transform: 'scale(1, 1)' },
      '25%': { transform: 'scale(1.1, 1.1)' },
      '50%': { transform: 'scale(0.9, 0.9)' },
      '75%': { transform: 'scale(1.05, 1.05)' },
    },
  }

  output[theme.mediaInverse.sm] = {
    counter: {
      width: 15,
      height: 15,
      top: '-2px',
    },
  }

  return output
}

export default style
